/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { ScrEnvironment } from "src/environments/environment";
import { CreateAccountRequest } from './account.service';
import { NOCRED, WITHCRED } from "./authentication.service";
import { IScrBaseResponse, ScrBaseService } from "./base.service";
import { ScrServiceManager } from "./servicemanager.service";
import { CacheService } from "./cache.service";
import { Account } from "../models/account.model";


export interface UpdateAccountResponse extends IScrBaseResponse {
  account: Account;
}

export interface ExistsResponse extends IScrBaseResponse {
  emailExists?: boolean;
  userExists?: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class CreateAccountService extends ScrBaseService {

  constructor(
    serviceManager: ScrServiceManager,
    private environment: ScrEnvironment,
    private cache: CacheService,
    private http: HttpClient) {
    super(serviceManager);
  }

  public checkUserId(username: string): Observable<ExistsResponse> {
    const url = `${this.environment.base}/public/account/validate?key=userName&value=${encodeURIComponent(username)}`;
    return this.nobusy<IScrBaseResponse>(() => this.http.get<IScrBaseResponse>(url, NOCRED ));
  }

  public checkEmail(email: string): Observable<ExistsResponse> {
    const url = `${this.environment.base}/public/account/validate?key=email&value=${encodeURIComponent(email)}`;
    return this.nobusy<IScrBaseResponse>(() => this.http.get<IScrBaseResponse>(url, NOCRED ));
  }

  public createAccount(account: CreateAccountRequest, captcha?: string): Observable<IScrBaseResponse> {
    const acc: any = { ...account };
    acc.userName = acc.username;
    delete acc.username;
    if (acc.companySymbol)
      acc.companySymbol = acc.companySymbol.toUpperCase();

    const req = { account: acc, user: acc, routeUrl: 'sec/verify' };
    const url = `${this.environment.base}/public/account`;
    return this.http.post<IScrBaseResponse>(url, captcha ? { ...req, userCaptchaResp: captcha } : req, NOCRED );
  }

  public updateAccount(account: CreateAccountRequest, updateOrdersApplicantContact = false, updateOrdersBillingContact = false ): Observable<UpdateAccountResponse> {

    const acc: any = { ...account };
    acc.userName = acc.username;
    delete acc.username;
    if (acc.companySymbol)
      acc.companySymbol = acc.companySymbol.toUpperCase();

    const req = { account: acc, updateOrdersApplicantContact, updateOrdersBillingContact };

    const url = `${this.environment.base}/secure/account`;
    this.cache.set('account', undefined);
    this.cache.invalidate('addressbook');

    return this.http.put<UpdateAccountResponse>(url, req, WITHCRED ).pipe(tap(rsp => {
      if ((rsp.status === 'success') && (rsp.account)) {
        this.cache.set('account', rsp.account, Number.MAX_SAFE_INTEGER);
      }
    }));
  }

}